export { HelperText as default } from "./styled";
